import classNames from 'classnames';
import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import { useSearch } from 'wouter';

import PillButton from '../buttons/PillButton';

import styles from '../../styles/menus/sort-menu.module.css';

export interface SortMenuProps {
    url: string;
    className?: string | null;
}

function SortMenu({ url, className = null }: SortMenuProps) {
    const search = useSearch();
    const { sort: sortParam = null } = queryString.parse(search);
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                <PillButton
                    href={`${url}`}
                    compact
                    branded
                    bordered
                    active={sortParam === null}
                    className={styles.filter}
                >
                    <FormattedMessage defaultMessage="Plus récents" description="Filter label" />
                </PillButton>
                <PillButton
                    href={`${url}?sort=popular`}
                    compact
                    branded
                    bordered
                    active={sortParam === 'popular'}
                    className={styles.filter}
                >
                    <FormattedMessage defaultMessage="Plus populaires" description="Filter label" />
                </PillButton>
            </div>
        </div>
    );
}

export default SortMenu;
